export const SFChat = (personDetails: PersonAccountHelpers.LoggedInDetails) =>{

  const setupMessagingListener = () => {
    window.addEventListener("onEmbeddedMessagingReady", () => {
      if (window.embeddedservice_bootstrap?.prechatAPI) {
        window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
          "EndUserAccountId": personDetails?.myProfile.id,
          "Referring_Site": "Midland Client Portal",
        });

        window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
          "_firstName": {
            "value": personDetails?.myProfile.firstName,
            "isEditableByEndUser": false
          },
          "_lastName": {
            "value": personDetails?.myProfile.lastName,
            "isEditableByEndUser": false
          },
          "_email": {
            "value": personDetails?.myProfile.email,
            "isEditableByEndUser": false
          }
        });
      }
    });
  };

  const initEmbeddedMessaging = () => {
    try {
      if (window.embeddedservice_bootstrap) {
        window.embeddedservice_bootstrap.settings.language = 'en_US';
        
        window.embeddedservice_bootstrap.init(
          '00D30000000Yy42',
          'Enhanced_CS_Chat_Deployment',
          'https://entrust.my.site.com/ESWEnhancedCSChatDeplo1771257346614',
          {
            scrt2URL: 'https://entrust.my.salesforce-scrt.com'
          }
        );
      }
    } catch (err) {
      console.error('Error loading Embedded Messaging: ', err);
    }
  };

  const loadSalesforceScript = () => {
    const existingScript = document.getElementById('sf-embedded-messaging');
    if (existingScript) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'sf-embedded-messaging';
    script.type = 'text/javascript';
    script.src = 'https://entrust.my.site.com/ESWEnhancedCSChatDeplo1771257346614/assets/js/bootstrap.min.js';
    
    script.onload = () => {
      const checkBootstrap = setInterval(() => {
        if (window.embeddedservice_bootstrap) {
          clearInterval(checkBootstrap);
          initEmbeddedMessaging();
        }
      }, 100);
    };

    script.onerror = (error) => {
      console.error('Failed to load Salesforce Embedded Messaging script:', error);
    };

    document.head.appendChild(script);
  };

  setupMessagingListener();
  loadSalesforceScript();

  return () => {
    const script = document.getElementById('sf-embedded-messaging');
    if (script) {
      script.remove();
    }
    window.removeEventListener("onEmbeddedMessagingReady", () => {});
  };
}